const ClubServiceDashboard = () => {
  return <div>ClubServiceDashboard</div>;
};

export default ClubServiceDashboard;
